import React from 'react';

const TournamentData = ({ torneo }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'Non specificata';
    
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
      });
    } catch (error) {
      return 'Data non valida';
    }
  };

  const isDeadlineWarning = (dateString) => {
    if (!dateString) return false;
    
    try {
      const deadline = new Date(dateString);
      const now = new Date();
      const daysUntilDeadline = Math.ceil((deadline - now) / (1000 * 60 * 60 * 24));
      
      return daysUntilDeadline <= 7 && daysUntilDeadline >= 0;
    } catch (error) {
      return false;
    }
  };

  if (!torneo) {
    return (
      <div className="inscription-form-section">
        <div className="inscription-tournament-section-header">
          <i className="fas fa-trophy"></i>
          <h2>Dati Torneo</h2>
        </div>
        <div className="inscription-tournament-section-content">
          <p>Caricamento dati torneo...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="inscription-form-section">
      <div className="inscription-section-header">
        <i className="fas fa-trophy"></i>
        <h2>Dati Torneo</h2>
      </div>
      
      {/* Content della sezione */}
      <div className="inscription-tournament-section-content">
        <div className="inscription-tournament-header-content">
          {/* Locandina quadrata */}
          <div className="inscription-tournament-header-poster">
            {torneo.locandina ? (
              <img 
                src={torneo.locandina.startsWith('data:') ? torneo.locandina : `data:image/jpeg;base64,${torneo.locandina}`}
                alt={`Locandina ${torneo.nome}`}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
            ) : null}
            <div 
              className="inscription-tournament-header-poster-placeholder" 
              style={{display: torneo.locandina ? 'none' : 'flex'}}
            >
              <i className="fas fa-trophy"></i>
              <span>Locandina non disponibile</span>
            </div>
          </div>

          {/* Informazioni torneo */}
          <div className="inscription-tournament-header-info">
            {/* Titolo ed edizione */}
            <div className="inscription-tournament-header-title">
              
              {torneo.edizione && (
                <div>
                  <h3>{torneo.edizione} EDIZIONE</h3>
                  <h3 className="inscription-tournament-header-name">{torneo.nome}</h3>
                </div>
              )}
            </div>

            {/* Dettagli compatti */}
            <div className="inscription-tournament-header-details">
              <div className="inscription-tournament-header-detail">
                {/* <i className="fas fa-calendar-alt"></i> */}
                <div className="inscription-tournament-header-detail-content">
                  <div className="inscription-tournament-header-detail-label">Data</div>
                  <div className="inscription-tournament-header-detail-value">
                    {formatDate(torneo.data)}
                  </div>
                </div>
              </div>

              <div className="inscription-tournament-header-detail">
                {/* <i className="fas fa-map-marker-alt"></i> */}
                <div className="inscription-tournament-header-detail-content">
                  <div className="inscription-tournament-header-detail-label">Luogo</div>
                  <div className="inscription-tournament-header-detail-value">
                    {torneo.luogo || 'Da definire'}
                  </div>
                </div>
              </div>

              <div className={`inscription-tournament-header-detail ${isDeadlineWarning(torneo.chiusuraIscrizioni) ? 'deadline-warning' : ''}`}>
                {/* <i className="fas fa-clock"></i> */}
                <div className="inscription-tournament-header-detail-content">
                  <div className="inscription-tournament-header-detail-label">
                    Scadenza{isDeadlineWarning(torneo.chiusuraIscrizioni) ? ' - ATTENZIONE!' : ''}
                  </div>
                  <div className="inscription-tournament-header-detail-value">
                    {formatDate(torneo.chiusuraIscrizioni)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TournamentData;